import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-5 w-20 bg-white/10 animate-pulse rounded" />
        <div className="h-5 w-20 bg-white/10 animate-pulse rounded" />
        <div className="h-5 w-20 bg-white/10 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-white/80 hover:text-white transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <footer className="bg-[oklch(0.12_0_0)] text-white py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
          {}
          <div className="md:col-span-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409748/img/website_logo_white.png" alt="gp2bcexpress logo" className="h-7 mb-4" />
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Fast, reliable ERP migration across North America. Specialized in
              Microsoft Dynamics GP to Dynamics 365 Business Central with
              precision, speed, and audit-ready results.
            </p>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <MapPin className="size-5 text-white/60 shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">
                  Canada and U.S. (specific address not provided)
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-5 text-white/60 shrink-0" />
                <Link to="tel:+16043379989" className="text-white/70 hover:text-white text-sm transition-colors duration-[var(--duration-fast)]">
                  604-337-9989
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-5 text-white/60 shrink-0" />
                <Link to="mailto:info@GP2BCexpress.com" className="text-white/70 hover:text-white text-sm transition-colors duration-[var(--duration-fast)]">
                  info@GP2BCexpress.com
                </Link>
              </div>
            </div>
            <div className="mt-4 text-white/70 text-sm">
              <p className="font-medium text-white/90 mb-1">Business Hours</p>
              <p>Monday to Friday, 9am - 5pm PST</p>
            </div>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <MenuProvider menu_id="13">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-white/60 text-sm text-center lg:text-left">
            © {new Date().getFullYear()} gp2bcexpress. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}